import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';

const api = new Api('dashboard/predictions');
const funnelChartApi = new Api('dashboard/predictions/funnel_chart');

function* loadData({ payload }) {
  try {
    const { page = 1, column, order, filter = '' } = payload;
    const pageSize = 6;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, column, order, filter, ...payload, pageSize } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records: data, filters, totalCount: total, filteredCount: filteredTotal } = result.data.success.data;

      yield put(actions.loadDataSuccess({ data, total, filteredTotal, filters }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFunnelData({ payload }) {
  try {
    const result = yield call(
      sendRequest,
      funnelChartApi.load,
      { search: { ...payload } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { data } = result.data.success;

      yield put(actions.loadFunnelDataSuccess({ chart: data.chart }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.LOAD_FUNNEL_DATA, loadFunnelData)]);
}
